import type { RouteRecordRaw } from 'vue-router'
import PassThrough from '@/components/layout/PassThrough.vue'
import { UserSettingsRoutes } from '@/routes/user/settings'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'

export const userAccountsDetailsRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.details',
  'my-account',
  UserSettingsRoutes.AccountDetails,
)

export const userAccountsSecurityRoute: RouteRecordRaw = {
  name: 'user.accounts.security',
  path: 'security',
  component: PassThrough,
  redirect: { name: UserSettingsRoutes.AccountSecurity },
  children: [
    getOldRouteWithRedirect(
      'user.accounts.security.2faSetup',
      'two-factor-authentication',
      UserSettingsRoutes.AccountSecurity2faSetup,
    ),
  ],
}

export const userAccountsNotificationsRoute: RouteRecordRaw = getOldRouteWithRedirect(
  'user.accounts.notifications',
  'notifications',
  UserSettingsRoutes.AccountNotifications,
)
